import {
  UPDATE_RENTAL_FORM_V2_REQUEST,
  UPDATE_RENTAL_FORM_V2_SUCCESS,
} from 'Constants/redux';
import service from '../../api/service';
import { ROOT_URL } from '../../api';
import AppState from '../../types/AppState';
import { ThunkAction } from 'redux-thunk';
import { RentalFormActionTypes } from './types';
import RentalVersionData from '../../types/RentalVersionData';
import axios from 'axios';
import deepSnakeCaseKeys from '../deepSnakeCaseKeys';

export const updateRentalVersion =
  (
    id: number,
    payload: Partial<RentalVersionData>,
    token: string | null,
    cancelToken = axios.CancelToken.source().token
  ): ThunkAction<Promise<void>, AppState, unknown, RentalFormActionTypes> =>
  async (dispatch) => {
    dispatch({ type: UPDATE_RENTAL_FORM_V2_REQUEST });

    try {
      const response = await service.put(
        `${ROOT_URL}/rental_versions/${id}${
          token ? '?rentalToken=' + token : ''
        }`,
        {
          rental_version: { ...deepSnakeCaseKeys(payload), pricing: undefined },
        },
        { cancelToken }
      );

      dispatch({
        type: UPDATE_RENTAL_FORM_V2_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
